// extracted by mini-css-extract-plugin
export default {"match-bid-logo":"adc__match-bid-logo--xPUeo"};